import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";
import { multipleSelect } from "multiple-select-v4.3.7";

registerComponent(
  "multiple-select",
  class MultipleSelect extends WYATTElement {
    constructor() {
      super();

      this.instance = null;
      this.selectElement = this.querySelector("select");
    }

    connectedCallback() {
      this.instance = multipleSelect(this.selectElement, this.config ?? {});
    }

    reinitialize() {
      this.instance.destroy();
      this.instance = null;
      this.connectedCallback();
    }
  }
);
